import api from '../utils/api';

const alumniService = {
  listRecords: async (params) => {
    try {
      return await api.get('/api/alumni/records', { params });
    } catch (error) {
      console.error('Error fetching alumni records:', error);
      throw error;
    }
  },
  createRecord: async (data) => {
    try {
      return await api.post('/api/alumni/records', data);
    } catch (error) {
      console.error('Error creating alumni record:', error);
      throw error;
    }
  },
  updateRecord: async (recordId, data) => {
    try {
      return await api.put(`/api/alumni/records/${recordId}`, data);
    } catch (error) {
      console.error('Error updating alumni record:', error);
      throw error;
    }
  },
  deleteRecord: async (recordId) => {
    try {
      return await api.delete(`/api/alumni/records/${recordId}`);
    } catch (error) {
      console.error('Error deleting alumni record:', error);
      throw error;
    }
  },
  sendOutreach: async (data) => {
    try {
      return await api.post('/api/alumni/outreach', data);
    } catch (error) {
      console.error('Error sending outreach:', error);
      throw error;
    }
  },

  listDonations: async (params) => {
    try {
      return await api.get('/api/alumni/donations', { params });
    } catch (error) {
      console.error('Error fetching donations:', error);
      throw error;
    }
  },
  createDonation: async (alumniId, data) => {
    try {
      return await api.post(`/api/alumni/${alumniId}/donations`, data);
    } catch (error) {
      console.error('Error creating donation:', error);
      throw error;
    }
  },
  deleteDonation: async (donationId) => {
    try {
      return await api.delete(`/api/alumni/donations/${donationId}`);
    } catch (error) {
      console.error('Error deleting donation:', error);
      throw error;
    }
  },
  approveDonation: async (donationId) => {
    try {
      return await api.post(`/api/alumni/donations/${donationId}/approve`);
    } catch (error) {
      console.error('Error approving donation:', error);
      throw error;
    }
  },
  rejectDonation: async (donationId, rejectionReason) => {
    try {
      return await api.post(`/api/alumni/donations/${donationId}/reject`, { rejection_reason: rejectionReason });
    } catch (error) {
      console.error('Error rejecting donation:', error);
      throw error;
    }
  },
  getDonationsSummary: async () => {
    try {
      return await api.get('/api/alumni/donations/summary');
    } catch (error) {
      console.error('Error fetching donations summary:', error);
      throw error;
    }
  },
};

export default alumniService;
